/**
 * @returns {boolean}
 */
export function hasDataLayer() {
    return (
        typeof window.dataLayer === 'object' &&
        Array.isArray(window.dataLayer)
    )
}
